export const getNumberIdFromLocalStorage = (key: string): number | null => {
  const id = localStorage.getItem(key)
  return id ? parseInt(id) : null
}
